module.exports = __webpack_public_path__ + "static/media/Tania1.6873ff94.jpeg";